import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { MetaService } from '../shared/meta.service';
import { IntlService } from '../shared/intl.service';

@Component({
    template: require('./partials/content-writing-edit.component.html'),
    providers: [DatePipe]
})
export class ContentWritingEditComponent extends Content implements OnInit { 

    public action: string = 'add';
    writingForm: FormGroup;
    url: string = "";
    isNew = true;

    constructor(public writingConfig: ConfigService, private writingIntlService: IntlService, private writingMetaService: MetaService, private utils: UtilsService, private datePipe: DatePipe, private formBuilder: FormBuilder, private router: Router, private writingService: ContentService, private writingRoute: ActivatedRoute) {
        super(writingConfig, writingIntlService, writingMetaService, writingService, writingRoute);
        this.setType('writing');
    }

    ngOnInit() {

        this.writingRoute.params.subscribe((params: Params) => {

            // NEW
            // Need to init the form for the view, for some reason
            this.buildForm(this.isNew, null);
            
            // UPDATE
            if (params['id'] != 0) {
                this.action = 'update';
                this.isNew = false;
                this.writingService.getContent(this.type, { _id: params['id'] }, true).then(response => {
                    this.content = response;
                    this.buildForm(this.isNew, this.content);
                    this.url = this.content.url;
                });
            }

            // Clean url - only works for new content
            this.writingForm.valueChanges.subscribe(e => {
                setTimeout(()=>{
                    this.url = this.cleanUrl(this.url);
                },300);
            });

        });

        // Current language
        this.writingRoute.parent.params.subscribe((params: Params) => {
            this.currentLanguage = params['lg'];
        });

    }

    buildForm(isNew: boolean, content: any) {
        this.writingForm = this.formBuilder.group({
            cid: isNew? null : content.cid,
            active: isNew? false : content.active,
            author: [isNew? null : content.author, [
                Validators.required
            ]],
            // languages: isNew ? this.formBuilder.array([]) : this.formBuilder.array(this.content.languages),
            title: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.title), // validation at group level does not work
            summary: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.summary), // idem
            content: isNew ? this.formBuilder.group(this.getIntlInitObject()) : this.formBuilder.group(this.content.content), // idem
            url: [isNew? null : content.url, [
                Validators.required
            ]],
            date: [this.datePipe.transform(isNew ? new Date() : content.date, 'yyyy-MM-dd'), []],
            update_date: [isNew ? null : this.datePipe.transform(content.update_date, 'yyyy-MM-dd'),[]],
            tags: isNew ? this.formBuilder.array([null]) : this.formBuilder.array(this.content.tags)
        });
        if(!isNew) 
            this.writingForm.addControl('_id', new FormControl(content._id));
    }

    onSubmit() {
        // update date
        this.writingForm.controls['update_date'].setValue(this.datePipe.transform(new Date(), 'yyyy-MM-dd'));
        // supported languages
        let supportedLanguages = this.getSupportedLanguages();
        this.writingForm.addControl('languages',this.formBuilder.array(supportedLanguages))
        // save
        this.writingService.saveContent('writing', this.action, this.writingForm.value).then(res => {
            // nav
            this.router.navigate(['writings'], { relativeTo: this.route.parent });
        });
    }

    getSupportedLanguages(){
        let supportedLanguages = [];
        for(let lg of this.config.data.APP.LANGUAGES.SUPPORTED){
            if(this.writingForm.get(['content',lg]).value != "")
                supportedLanguages.push(lg);
        }   
        return supportedLanguages;
    }

    // buildUrl() {
    //     let url = this.url;
    //     if (this.writingForm.get('author').value) {
    //         url = this.writingForm.get('author').value + '-' + url;
    //     }
    //     this.url = this.cleanUrl(url);
    // }

    cleanUrl(str){
        str = this.utils.removeAccents(str);
        str = str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        str = str.replace(/--+/, "-");
        return str;
    }


    onAddTag() {
        let tags = this.writingForm.controls['tags'] as FormArray;
        tags.push(this.formBuilder.control(null));
    }

    onRemoveTag(index: any) {
        let tags = this.writingForm.controls['tags'] as FormArray;
        tags.removeAt(index);
    }

    keyupEditorHandlerFunction(fieldPath: string[], text: string) {
        this.writingForm.get(fieldPath).patchValue(text);
        //console.log(text);
    }

    public deleteContent(type: string, id: string){ 
        this.writingService.deleteContent(type,id);
        this.router.navigate(['writings/reload'], {relativeTo: this.route.parent});
        setTimeout(() => {
            this.router.navigate(['writings'], {relativeTo: this.route.parent});
        }, 500);  
    }

} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-writing-edit.component.ts